import fetchAPI, { LatestAPIVersion, WebAPIBaseUrl } from 'utils/fetchAPI';

export const RECEIVED_ALL_POLLS = 'RECEIVED_ALL_POLLS';

function savePolls(items) {
  return { type: RECEIVED_ALL_POLLS, items };
}

const handleResponse = ({ resolve, reject, json }) => {
  if (json.error_code) {
    reject(json.error_message);
  }
  if (json.status_code && json.status_code !== 200) {
    reject(json.error_message);
  }
  resolve(json);
};

export const createPoll = ({
  title,
  question_lang,
  caption_lang,
  option_langs,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: '/polls',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        title,
        question_lang,
        caption_lang,
        option_langs,
      }),
    })
      .then(res => res.json())
      .then(json => {
        if (json.poll.id) return resolve(json);
        return reject(json);
      });
  });

export const getPolls = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: '/polls',
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => {
        dispatch(savePolls(json.polls));
        return resolve();
      });
  });

export const deletePoll = ({ id }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/polls/${id}`,
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1) {
          dispatch(
            savePolls(
              getState().polls.items.filter(
                poll => poll.id !== parseInt(id, 10)
              )
            )
          );
          return resolve();
        }
        return reject();
      });
  });

export const copyPoll = ({ id }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/polls/${id}/copy`,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => handleResponse({ resolve, reject, json }));
  });

export const exportResult = ({ id }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/polls/${id}/csv`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => handleResponse({ resolve, reject, json }));
  });

export const setPollRecipient = ({
  time_to_send,
  valid_until,
  is_local,
  user_ids,
  id,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/polls/${id}/recipients`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        time_to_send,
        valid_until,
        is_local,
        user_ids,
      }),
    })
      .then(res => res.json())
      .then(json => handleResponse({ resolve, reject, json }));
  });

export const getPollResult = ({ id }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/polls/${id}/admin_result`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(json => handleResponse({ resolve, reject, json }));
  });



// WEBPACK FOOTER //
// ./app/actions/PollActionCreators.js